// extracted by mini-css-extract-plugin
module.exports = {"grid":"_382795c6","picture":"_65744626","image":"_7ebef7ef","title":"_e861200a","text":"_a895f170"};